import { Button, Popconfirm, Tooltip } from 'antd';
import { SwapOutlined, LoadingOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";

export const FlushAnalyseButton = ({ onConfirm, loading = false, disabled = false, className }) => {
    const { t: tReview } = useTranslation("review");

    const button = (
        <Button
            className={className}
            type="dashed"
            icon={loading ? <LoadingOutlined /> : <SwapOutlined />}
            danger={!disabled}
            loading={loading}
            disabled={disabled}
        >
            {tReview("flush.button")}
        </Button>
    );

    // Si disabled, pas de Popconfirm, juste le bouton avec tooltip
    if (disabled) {
        return (
            <Tooltip title={tReview("flush.tooltip_disabled") || tReview("flush.tooltip")}>
                {button}
            </Tooltip>
        );
    }

    return (
        <Tooltip title={tReview("flush.tooltip")}>
            <Popconfirm
                title={tReview("flush.title")}
                description={tReview("flush.description")}
                onConfirm={onConfirm}
                okText={tReview("flush.ok")}
                cancelText={tReview("flush.cancel")}
                placement="bottomRight"
            >
                {button}
            </Popconfirm>
        </Tooltip>
    );
};
